export const LIST_CONTACTS_REQUESTED = 'LIST_CONTACTS_REQUESTED';
export const LIST_CONTACTS_COMPLETED = 'LIST_CONTACTS_COMPLETED';
export const LIST_CONTACTS_FAILED = 'LIST_CONTACTS_FAILED';
export const LIST_CONTACTS_ABORTED = 'LIST_CONTACTS_ABORTED';

export const SET_CONTACT_REQUESTED = 'SET_CONTACT_REQUESTED';
export const SET_CONTACT_ABORTED = 'SET_CONTACT_ABORTED';
export const SET_CONTACT_COMPLETED = 'SET_CONTACT_COMPLETED';
export const SET_CONTACT_FAILED = 'SET_CONTACT_FAILED';

export const SET_CONTACT_REDIRECT_REQUESTED = 'SET_CONTACT_REDIRECT_REQUESTED';
export const SET_CONTACT_REDIRECT_ABORTED = 'SET_CONTACT_REDIRECT_ABORTED';
export const SET_CONTACT_REDIRECT_COMPLETED = 'SET_CONTACT_REDIRECT_COMPLETED';
export const SET_CONTACT_REDIRECT_FAILED = 'SET_CONTACT_REDIRECT_FAILED';

export const SET_CONTACT_REDIRECT_MARKED_REQUESTED =
  'SET_CONTACT_REDIRECT_MARKED_REQUESTED';
export const SET_CONTACT_REDIRECT_MARKED_ABORTED =
  'SET_CONTACT_REDIRECT_MARKED_ABORTED';
export const SET_CONTACT_REDIRECT_MARKED_COMPLETED =
  'SET_CONTACT_REDIRECT_MARKED_COMPLETED';
export const SET_CONTACT_REDIRECT_MARKED_FAILED =
  'SET_CONTACT_REDIRECT_MARKED_FAILED';

export const SET_CONTACT_REDIRECT_ASSERT_REQUESTED =
  'SET_CONTACT_REDIRECT_ASSERT_REQUESTED';
export const SET_CONTACT_REDIRECT_ASSERT_ABORTED =
  'SET_CONTACT_REDIRECT_ASSERT_ABORTED';
export const SET_CONTACT_REDIRECT_ASSERT_COMPLETED =
  'SET_CONTACT_REDIRECT_ASSERT_COMPLETED';
export const SET_CONTACT_REDIRECT_ASSERT_FAILED =
  'SET_CONTACT_REDIRECT_ASSERT_FAILED';

export const SET_CONTACT_REDIRECTACTION_REQUESTED =
  'SET_CONTACT_REDIRECTACTION_REQUESTED';
export const SET_CONTACT_REDIRECTACTION_ABORTED =
  'SET_CONTACT_REDIRECTACTION_ABORTED';
export const SET_CONTACT_REDIRECTACTION_COMPLETED =
  'SET_CONTACT_REDIRECTACTION_COMPLETED';
export const SET_CONTACT_REDIRECTACTION_FAILED =
  'SET_CONTACT_REDIRECTACTION_FAILED';

export const RESET_CONTACT_REDIRECTACTION_COMPLETED =
  'RESET_CONTACT_REDIRECTACTION_COMPLETED';

export const SET_CONTACT_REDIRECTROUTE_REQUESTED =
  'SET_CONTACT_REDIRECTROUTE_REQUESTED';
export const SET_CONTACT_REDIRECTROUTE_ABORTED =
  'SET_CONTACT_REDIRECTROUTE_ABORTED';
export const SET_CONTACT_REDIRECTROUTE_COMPLETED =
  'SET_CONTACT_REDIRECTROUTE_COMPLETED';
export const SET_CONTACT_REDIRECTROUTE_FAILED =
  'SET_CONTACT_REDIRECTROUTE_FAILED';
export const RESET_CONTACT_REDIRECTROUTE_COMPLETED =
  'RESET_CONTACT_REDIRECTROUTE_COMPLETED';

export const SET_CONTACT_REDIRECTONEVIEW_STATUSES_REQUESTED =
  'SET_CONTACT_REDIRECTONEVIEW_STATUSES_REQUESTED';
export const SET_CONTACT_REDIRECTONEVIEW_STATUSES_ABORTED =
  'SET_CONTACT_REDIRECTONEVIEW_STATUSES_ABORTED';
export const SET_CONTACT_REDIRECTONEVIEW_STATUSES_COMPLETED =
  'SET_CONTACT_REDIRECTONEVIEW_STATUSES_COMPLETED';
export const SET_CONTACT_REDIRECTONEVIEW_STATUSES_FAILED =
  'SET_CONTACT_REDIRECTONEVIEW_STATUSES_FAILED';

export const SET_CONTACT_ACTIVATEACCOUNTROUTE_REQUESTED =
  'SET_CONTACT_ACTIVATEACCOUNTROUTE_REQUESTED';
export const SET_CONTACT_ACTIVATEACCOUNTROUTE_ABORTED =
  'SET_CONTACT_ACTIVATEACCOUNTROUTE_ABORTED';
export const SET_CONTACT_ACTIVATEACCOUNTROUTE_COMPLETED =
  'SET_CONTACT_ACTIVATEACCOUNTROUTE_COMPLETED';
export const SET_CONTACT_ACTIVATEACCOUNTROUTE_FAILED =
  'SET_CONTACT_ACTIVATEACCOUNTROUTE_FAILED';

export const SET_CONTACT_REDIRECTRESET_REQUESTED =
  'SET_CONTACT_REDIRECTRESET_REQUESTED';
export const SET_CONTACT_REDIRECTRESET_ABORTED =
  'SET_CONTACT_REDIRECTRESET_ABORTED';
export const SET_CONTACT_REDIRECTRESET_COMPLETED =
  'SET_CONTACT_REDIRECTRESET_COMPLETED';
export const SET_CONTACT_REDIRECTRESET_FAILED =
  'SET_CONTACT_REDIRECTRESET_FAILED';

export const SET_CONTACTID_ROUTE_REQUESTED = 'SET_CONTACTID_ROUTE_REQUESTED';
export const SET_CONTACTID_ROUTE_ABORTED = 'SET_CONTACTID_ROUTE_ABORTED';
export const SET_CONTACTID_ROUTE_COMPLETED = 'SET_CONTACTID_ROUTE_COMPLETED';
export const SET_CONTACTID_ROUTE_FAILED = 'SET_CONTACTID_ROUTE_FAILED';

export const RESET_CONTACTID_ROUTE_REQUESTED =
  'RESET_CONTACTID_ROUTE_REQUESTED';
export const RESET_CONTACTID_ROUTE_ABORTED = 'RESET_CONTACTID_ROUTE_ABORTED';
export const RESET_CONTACTID_ROUTE_COMPLETED =
  'RESET_CONTACTID_ROUTE_COMPLETED';
export const RESET_CONTACTID_ROUTE_FAILED = 'RESET_CONTACTID_ROUTE_FAILED';

export const SET_CONTACTID_ACTION_REQUESTED = 'SET_CONTACTID_ACTION_REQUESTED';
export const SET_CONTACTID_ACTION_ABORTED = 'SET_CONTACTID_ACTION_ABORTED';
export const SET_CONTACTID_ACTION_COMPLETED = 'SET_CONTACTID_ACTION_COMPLETED';
export const SET_CONTACTID_ACTION_FAILED = 'SET_CONTACTID_ACTION_FAILED';

export const SEARCH_CONTACTS_REQUESTED = 'SEARCH_CONTACTS_REQUESTED';
export const SEARCH_CONTACTS_COMPLETED = 'SEARCH_CONTACTS_COMPLETED';
export const SEARCH_CONTACTS_FAILED = 'SEARCH_CONTACTS_FAILED';
export const GET_USERS_REQUESTED = 'GET_USERS_REQUESTED';
export const GET_USERS_ABORTED = 'GET_USERS_ABORTED';
export const GET_USERS_COMPLETED = 'GET_USERS_COMPLETED';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';
export const CREATE_USER_REQUESTED = 'CREATE_USER_REQUESTED';
export const CREATE_USER_ABORTED = 'CREATE_USER_ABORTED';
export const CREATE_USER_COMPLETED = 'CREATE_USER_COMPLETED';
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED';
export const RESET_CONTACT_REQUESTED = 'RESET_CONTACT_REQUESTED';
export const RESET_CONTACT_COMPLETED = 'RESET_CONTACT_COMPLETED';

export const RESEND_USER_REQUESTED = 'RESEND_USER_REQUESTED';
export const RESEND_USER_ABORTED = 'RESEND_USER_ABORTED';
export const RESEND_USER_COMPLETED = 'RESEND_USER_COMPLETED';
export const RESEND_USER_FAILED = 'RESEND_USER_FAILED';

export const CHANGE_EMAIL_REQUESTED = 'CHANGE_EMAIL_REQUESTED';
export const CHANGE_EMAIL_COMPLETED = 'CHANGE_EMAIL_COMPLETED';
export const CHANGE_EMAIL_FAILED = 'CHANGE_EMAIL_FAILED';
export const CHANGE_PASSWORD_REQUESTED = 'CHANGE_PASSWORD_REQUESTED';
export const CHANGE_PASSWORD_COMPLETED = 'CHANGE_PASSWORD_COMPLETED';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';
export const RESET_TOAST_REQUESTED = 'RESET_TOAST_REQUESTED';
export const RESET_TOAST_COMPLETED = 'RESET_TOAST_COMPLETED';

export const DOWNLOAD_CLIENT_USERS_REQUESTED =
  'DOWNLOAD_CLIENT_USERS_REQUESTED';
export const DOWNLOAD_CLIENT_USERS_COMPLETED =
  'DOWNLOAD_CLIENT_USERS_COMPLETED';
export const DOWNLOAD_CLIENT_USERS_FAILED = 'DOWNLOAD_CLIENT_USERS_FAILED';

export const DOWNLOAD_ADVISER_USERS_REQUESTED =
  'DOWNLOAD_ADVISER_USERS_REQUESTED';
export const DOWNLOAD_ADVISER_USERS_COMPLETED =
  'DOWNLOAD_ADVISER_USERS_COMPLETED';
export const DOWNLOAD_ADVISER_USERS_FAILED = 'DOWNLOAD_ADVISER_USERS_FAILED';

export const GET_CONTACT_STATUS_REQUESTED = 'GET_CONTACT_STATUS_REQUESTED';
export const GET_CONTACT_STATUS_COMPLETED = 'GET_CONTACT_STATUS_COMPLETED';
export const GET_CONTACT_STATUS_FAILED = 'GET_CONTACT_STATUS_FAILED';

export const RESET_CONTACT_STATUS_REQUESTED = 'RESET_CONTACT_STATUS_REQUESTED';
export const RESET_CONTACT_STATUS_COMPLETED = 'RESET_CONTACT_STATUS_COMPLETED';

export const GET_CONTACT_REDIRECTONEVIEW_STATUSES_COMPLETED =
  'GET_CONTACT_REDIRECTONEVIEW_STATUSES_COMPLETED';
export const GET_CONTACT_REDIRECTONEVIEW_STATUSES_FAILED =
  'GET_CONTACT_REDIRECTONEVIEW_STATUSES_FAILED';
